module.exports = function (fox) {
	'use strict';
	require('./templates/expremium.a.tpl')(fox);
	require('./widget/expremiumUserPopup.es.js')(fox);
	require('./css/_gui-elem.css');

};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/expremiumuser/index.js
// module id = 54
// module chunks = 4